// extracted by mini-css-extract-plugin
export default {"layout":"yAE3OaEP47MnlC13rc2A","main":"y8znDo5NE3g27pitVqYR"};